/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import withHeaderFooter, { IWithHeaderFooterProps } from "@/app/csr-src/hocs/with-header-footer";
import Recommend from "@/common-components-src/js/recommend/index";
import { addCartUtil } from "@/app/csr-src/utils/cartUtils";
import BreadCrumb from "@/app/csr-src/components/breadCrumb";
import OrderDetailComponents from "./components/orderDetailComponents";
import { Helmet } from "react-helmet";
import CommonButton from "./components/commonButton";
import i18next from "i18next";
import styles from "./orderDetail.module.scss";
// 埋点
import { sendPv } from "@/tracks/25344";
import { EXPOSURE_RECORD as Recommend_EXPOSURE_RECORD, sendClickTrack as Recommend_sendClickTrack } from "@/tracks/25355";

const OrderDetail = withHeaderFooter(
  observer(({ JDIHeader }: IWithHeaderFooterProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    // const [orderDetails, setOrderDetails] = useState<IOrderDetailRes | null>(null);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [productSkuIds, setProductSkuIds] = useState(""); // 逗号分隔的字符串skuid
    const [isEmptyPage, setIsEmptyPage] = useState<boolean>(false);
    // const [error, setError] = useState<string | null>(null);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const orderId = queryParams.get("orderId") || ""; // 获取订单ID

    // const loadOrderDetails = async () => {
    //   const requestData: IOrderDetailReq = { orderId: String(orderId) };
    //   const [err, orderDetailData] = await to(fetchOrderDetail(requestData));

    //   if (err) {
    //     setError("Failed to fetch order details");
    //     setOrderDetails(null);
    //   } else {
    //     setOrderDetails(orderDetailData as IOrderDetailRes);
    //     setError(null);
    //   }

    //   setLoading(false);
    // };

    // useEffect(() => {
    //   loadOrderDetails();
    // }, [orderId]);

    // if (loading) {
    //   return <div>Loading...</div>;
    // }

    // if (error) {
    //   return <div>{error}</div>;
    // }
    const initCartNumHandler = () => {
      JDIHeader?.current?.initCartNum();
    };

    useEffect(() => {
      sendPv.OrderCenter_Detail();
      window.scrollTo(0, 0); // 页面跳转时滚动到顶部
    }, []);

    const recommendAddCart = (item: { skuId: string }) => {
      addCartUtil([{ skuId: item?.skuId, num: "1" }], initCartNumHandler);
    };

    const pageLoadedHandler = (productSkuIds: any) => {
      setIsLoaded(true);
      if (productSkuIds.length > 0) {
        const firstTenItems = productSkuIds.slice(0, Math.min(productSkuIds.length, 10));
        setProductSkuIds(firstTenItems.join(","));
      }
    };

    return !isEmptyPage ? (
      <div className={styles.order_detail_wrap}>
        <Helmet>
          <title>{`My Order Details | #${orderId} | Joybuy`}</title>
          <meta
            name="description"
            content="View the details of your order on Joybuy.com. Track your purchase, check shipping status, and enjoy fast shipping and delivery guarantee on all items."
          />
        </Helmet>
        <div className={styles.detail_inner_wrap}>
          <BreadCrumb
            list={[
              { name: "Me", url: "/profile" },
              { name: "My orders", url: "/profile/my-orders" },
              { name: t("order.orderList.orderItems.headerOrderdetail") },
            ]}
          />
          <div className={styles.order_content}>
            <OrderDetailComponents
              orderId={orderId}
              handleInitCartNum={initCartNumHandler}
              pageLoadedHandler={pageLoadedHandler}
              changePageHandler={(val) => {
                setIsEmptyPage(val);
              }}
            />
          </div>
          {isLoaded && (
            <Recommend
              sceneCode="order_detail"
              mainSkus={productSkuIds}
              addCartFn={recommendAddCart}
              trackParams={{
                RecomSku_Expo: Recommend_EXPOSURE_RECORD.OrderCenter_Detail_RecomSku_Expo,
                RecomSku_Tab_Expo: Recommend_EXPOSURE_RECORD.OrderCenter_Detail_RecomSku_Tab_Expo,
                RecomSku_Addcart_Expo: Recommend_EXPOSURE_RECORD.OrderCenter_Detail_RecomSku_Addcart_Expo,
                productClick: Recommend_sendClickTrack.OrderCenter_Detail_RecomSku,
                tabClick: Recommend_sendClickTrack.OrderCenter_Detail_RecomSku_Tab,
                addCartClick: Recommend_sendClickTrack.OrderCenter_Detail_RecomSku_Addcart,
              }}
            />
          )}
        </div>
      </div>
    ) : (
      <div className={styles.emptyBlock}>
        {/* 已删除的订单详情拦截弹框 */}
        <Dialog open={isEmptyPage}>
          <DialogContent>{t("order.orderDetail.deletedModal.modalContent")}</DialogContent>

          {/* Button */}
          <DialogActions>
            <CommonButton
              variant="contained"
              onClick={() => {
                navigate("/profile/my-orders", { replace: true });
              }}
            >
              {t("order.orderDetail.deletedModal.btnText")}
            </CommonButton>
          </DialogActions>
        </Dialog>
      </div>
    );
  }),
);

export default OrderDetail;
